module.exports = __webpack_public_path__ + "static/media/renova-loginback.8e23f371.jpg";